import { Component, Input } from '@angular/core';

@Component({
  selector: 'tabs-navbar',
  templateUrl: './tabs-navbar.component.html',
  styleUrls: ['./tabs-navbar.component.css']
})
export class TabsNavbarComponent {
  @Input() tabLinks: Array<any>;

}
